import { UserCircle, Lock, Shield } from 'lucide-react';

const PrivacySectionB = () => {
  const privacyPoints = [
    {
      icon: UserCircle,
      title: "You own your data",
      description: "We don't sell it to advertisers. Ever."
    },
    {
      icon: Lock,
      title: "You control access",
      description: "Decide who sees your stats—family, doctors, or no one."
    },
    {
      icon: Shield,
      title: "Secure by default",
      description: "Bank-level encryption protects your health details."
    }
  ];

  return (
    <section className="py-16">
      <div className="bg-gradient-to-br from-primary/5 via-primary/8 to-primary/3 rounded-2xl p-8 lg:p-12 border border-primary/10">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10">
            <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-2">
              Your business is your business.
            </h2>
            <p className="text-lg text-muted-foreground">
              We built SeniorThrive to help you live independently, not to spy on you.
            </p>
          </div>
          
          {/* Privacy Points */}
          <div className="grid md:grid-cols-3 gap-6">
            {privacyPoints.map((point, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mx-auto mb-3">
                  <point.icon className="w-6 h-6 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="font-semibold text-foreground mb-1">{point.title}</h3>
                <p className="text-muted-foreground text-sm">{point.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacySectionB;
